import React from 'react';
import Modal from '@material-ui/core/Modal';
import { makeStyles } from '@material-ui/styles';
import IconButton from '@material-ui/core/IconButton';
import EditNoteIcon from '@material-ui/icons/Description';
import Button from '@material-ui/core/Button';
import AddIcon from '@material-ui/icons/Add';
import CloseIcon from '@material-ui/icons/Close';

const useStyles = makeStyles(theme => ({
  wrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  paper: {
    width: 800,
    height: 900,
    maxWidth: 'calc(100% - 20px)',
    maxHeight: 'calc(100% - 20px)',
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    outline: 'none',
    display: 'flex',
    flexDirection: 'column',
  },
  header: {
    backgroundColor: '#f4f4f4',
    padding: '1em 2.5em',
    position: 'relative',
  },
  title: {
    width: '100%',
    fontSize: '1.25em',
    textAlign: 'center',
    paddingRight: '1em',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    fontWeight: 600,
  },
  closeButton: {
    position: 'absolute',
    top: 0,
    right: 8,
  },
  body: {
    padding: '1em 2.5em',
    overflowY: 'auto',
  },
  noteList: {
    padding: 0,
    listStyleType: 'none',
    '& > li': {
      fontSize: '1.25em',
      padding: '0.25em 0.5em',
      cursor: 'pointer',
      borderRadius: 5,
      display: 'flex',
      alignItems: 'center',

      '&:hover': {
        background: '#eee',
      },
      '& span': {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        width: '100%',
      },
    },
    '& svg': {
      color: '#999',
      marginRight: '0.25em',
      display: 'inline-block',
    },
  },
  action: {
    margin: '2em 0 1em',
    textAlign: 'center',
    '& svg': {
      marginRight: 5,
    },
    '& button': {
      border: `1px solid ${theme.palette.primary.light}`,
      paddingRight: 15,
    }
  },
  '@media(max-width: 500px)': {
    header: {
      padding: '1em 1.5em 5px',
    },
    paper: {
      maxWidth: '100%',
      maxHeight: '100%',
    },
    body: {
      padding: '1em 1.5em',
    },
  }
}));

function NoteListModal (props) {
  const classes = useStyles();

  const handleClose = () => {
    props.close(false);
  }

  const openNote = (note) => {
    handleClose();
    props.setNote({ ...note, open: true });
    props.addRecentNote(note.id);
  }

  const newNote = () => {
    props.setNote({ open: true, title: '', content: '' });
    handleClose();
  }

  return (
    <Modal open={props.open} onClose={handleClose} className={classes.wrapper}>
      <div className={classes.paper}>
        <div className={classes.header}>
          <div className={classes.title}>Wybierz notatkę do edycji</div>
          <IconButton className={classes.closeButton} onClick={handleClose}>
            <CloseIcon />
          </IconButton>
        </div>
        <div className={classes.body}>
          <ul className={classes.noteList}>
            {props.notes.map(note => {
              const { id, title } = note;
              return <li key={id} onClick={() => openNote(note)}><EditNoteIcon /> <span>{title}</span></li>
            })}
          </ul>
          {props.notes.length === 0 && <div>
            Obecnie nie masz żadnych notatek. Utwórz nową notatkę klikając na przycisk "DODAJ NOWĄ"
          </div>}
          <div className={classes.action}>
            <Button color="primary" onClick={newNote}><AddIcon /> Dodaj nową</Button>
          </div>
        </div>
      </div>
    </Modal>
  );
}

export default NoteListModal;
